(() => {
  const init = () => {
    const root = document.querySelector('.hd4-pdp');
    const story = document.querySelector('.hd4-story');
    if (!root || !story || root.dataset.hd4Ready) return;
    root.dataset.hd4Ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-variant-json]')?.textContent || '[]');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:document.querySelector('#hd26-product-data') ? JSON.parse(document.querySelector('#hd26-product-data').textContent).currency : 'EUR'});
    const update = () => {
      const selected = [...root.querySelectorAll('fieldset.variant-input-wrap input:checked')].map(e=>e.value);
      root.querySelectorAll('fieldset.variant-input-wrap').forEach((fieldset,index) => {
        if (index === 0) return;
        const baseline = variants.find(v=>v.options.every((value,i)=>value === (i === index ? 'Ohne' : selected[i])));
        if (!baseline) return;
        fieldset.querySelectorAll('.variant-input').forEach(wrapper=>{
          const input = wrapper.querySelector('input');
          const extra = wrapper.querySelector('.hd26-option-extra');
          if (!input || !extra || input.value === 'Ohne') return;
          const candidate = variants.find(v=>v.options.every((value,i)=>value === (i === index ? input.value : selected[i])));
          if (candidate) extra.textContent = '+' + formatter.format((candidate.price-baseline.price)/100);
        });
      });
      const colour = root.querySelector('.hd-pdp-colour-options input:checked')?.value;
      const keys = {'Blau':'blau','Rot':'rot','Grün':'gruen','Schwarz':'schwarz'};
      const key = keys[colour];
      if (!key) return;
      story.querySelectorAll('[data-hd4-photo]').forEach(holder => {
        const type = holder.dataset.hd4Photo;
        const source = root.querySelector(`.product-main-slide[data-group$="_${key === 'gruen' ? 'gr-n' : key}"] img[src*="-${key}-${type}"]`);
        const target = holder.querySelector('img');
        if (!source || !target || target.dataset.colour === key) return;
        target.src = source.currentSrc || source.src;
        target.srcset = source.srcset;
        target.alt = source.alt;
        target.dataset.colour = key;
      });
    };
    root.addEventListener('change', () => requestAnimationFrame(update));
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
